// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"f718360d","741":"adf0f4d3","845":"43df4d5c"}[chunkId] + ".chunk.css";
};